import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'react-bootstrap';
import { v4 } from 'uuid';

import Avatar from '../Avatar';
import Icon from '../Icon';

export default function Activity({
  title,
  data,
  appendHeader,
  styleCard,
  classCard,
}) {
  return (
    <Card className="mb-4">
      <Card.Header>
        <h5 className="card-heading">{title}</h5>
      </Card.Header>
      <Card.Body style={styleCard} className={classCard}>
        {appendHeader}
        <div className="list-group list-group-flush list-group-timeline">
          {data.map((item) => (
            <div className="list-group-item px-0" key={v4()}>
              <Row>
                <Col xs="auto">
                  {item.icon ? (
                    <div className="avatar me-2">
                      <div className="position-relative overflow-hidden rounded-circle h-100 d-flex align-items-center justify-content-center">
                        <Icon className="svg-icon-md" icon={item.icon} />
                      </div>
                    </div>
                  ) : (
                    <Avatar
                      image={item.img || '/img/user-profile-circle.png'}
                      className="me-2"
                      border
                      link={item.link || false}
                    />
                  )}
                </Col>
                <Col className="col ms-n3 pt-2 text-sm text-gray-800">
                  <strong className="text-dark">{item.name} </strong>{' '}
                  {item.text}
                  <div className="text-gray-500 small">{item.time}</div>
                </Col>
              </Row>
            </div>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
}

Activity.defaultProps = {
  data: [],
  title: 'Atividades',
  appendHeader: null,
  styleCard: undefined,
  classCard: undefined,
};

Activity.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      time: PropTypes.string,
      data: PropTypes.shape({
        img: PropTypes.string,
        link: PropTypes.string,
        name: PropTypes.string || PropTypes.node,
        text: PropTypes.string || PropTypes.node,
        time: PropTypes.string || PropTypes.node,
        icon: PropTypes.string,
      }),
    })
  ),
  appendHeader: PropTypes.node,
  title: PropTypes.string,
  styleCard: PropTypes.shape({}),
  classCard: PropTypes.string,
};
